<!-- Display minutes_before_closing and weekday of ClosingTimeRadioSpotEntry. -->

<template>
  <div
    v-if="entry.id && entry.spot.closingtime"
    class="mt-1"
    :title="$t('closingTimeTooltip')"
    data-cy="entry-closingtime"
  >
    <v-icon
      color="msr"
      class="mr-1"
      small
    >
      campaign
    </v-icon>
    <entry-weekdays
      class="mr-2"
      :entry="entry"
    />
    <div>
      <small
        v-if="entry.minutes_before_closing"
        class="msr--text nowrap"
      >{{ entry.minutes_before_closing }} {{ $t('minutesShort') }}</small>
      <!-- Fallback for older entries that still use .time instead of .minutes_before_closing -->
      <small
        v-else
        class="msr--text nowrap"
      >{{ entry.time }}</small>
    </div>
  </div>
</template>

<script>
import EntryWeekdays from '@/components/EntryWeekdays';

export default {
  components: {
    EntryWeekdays,
  },
  props: {
    entry: {
      type: Object,
      required: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/EntryClosingtime.vue